import React from 'react';
import { motion } from 'framer-motion';
import ForDetail from '../ForDetail';
import { hizmetlerData } from '../../data/hizmetler-data';
import { Link } from 'react-router';
import { containerVariants,itemVariants, } from '../../script/animation';
import { useTranslation } from 'react-i18next';


const Section1 = () => {

    const { i18n } = useTranslation();
    const currentLang = i18n.language 

  return (
    <div className="w-full grid grid-cols-11 relative bg-white">
      <div className="col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-x-20  gap-y-10 lg:gap-y-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
        >
          {hizmetlerData.map((item, index) => (
            <motion.div variants={itemVariants} key={index}>
              <Link
                to={`/hizmetler/${item.link}`}
                className="space-y-10"
              >
                <div className="flex space-x-3 cursor-pointer group hover:scale-105 duration-300">
                  <div className="h-16 w-16 bg-genesisBlue aspect-square rounded-md relative">
                    <img
                      src={`/images/hizmetler/${item.link}/${item.svg}.svg`}
                      className="absolute top-0 left-0 w-full aspect-square"
                      alt={item.name[currentLang]}
                    />
                  </div>
                  <div className="flex flex-col">
                    <h2 className="text-custombBlue text-30 font-bold">
                      {item.name[currentLang]}
                    </h2>
                    <p className="text-customGray text-18">{item.miniText[currentLang]}</p>
                    <ForDetail />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Section1;
